const AwsSettings = {
  REGION: "us-west-2",
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
  USER_POOL_APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_APP_CLIENT_ID,
};

export default AwsSettings;
